import { Add, AnnouncementOutlined } from "@mui/icons-material";
import { Badge, Box, Button, Divider, Typography } from "@mui/material";
import ResponseForm from "components/Response/ResponseForm";
import AnnouncementResponseList from "components/Response/AnnouncementResponseList";
import FormDrawer from "components/Shared/FormDrawer";
import { useAnnouncementDetailContext } from "contexts/AnnouncementDetailContext";
import React from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useAddAnnouncementResponseMutation,
  useUpdateAnnouncementResponseMutation,
} from "store/services/announcementApi";

const AnnouncementResponsesTab = () => {
  const [showResponseForm, setShowResponseForm] = React.useState(false);
  const [selectedResponse, setSelectedResponse] = React.useState(null);

  const { id: announcementId } = useParams();

  const { announcementDetail } = useAnnouncementDetailContext();

  const sortedResponses = [...announcementDetail?.responses]?.sort((a, b) =>
    a?.createdAt > b?.createdAt ? -1 : 1
  );

  // RTK Query
  const [addResponse, { isLoading: addingResponse }] =
    useAddAnnouncementResponseMutation();

  const [updateResponse, { isLoading: updatingResponse }] =
    useUpdateAnnouncementResponseMutation();

  // methods
  const handleCancelResponse = () => {
    setShowResponseForm(false);
    setSelectedResponse(null);
  };

  const handleAddResponse = async (data) => {
    const payload = {
      ...data,
      announcementId,
    };

    try {
      await addResponse(payload).unwrap();
      toast.success("Response successfully added!");
      handleCancelResponse();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add response!");
    }
  };

  const handleEditResponse = (response) => {
    setShowResponseForm(true);
    setSelectedResponse(response);
  };

  const handleUpdateResponse = async (data) => {
    try {
      await updateResponse({
        ...data,
        announcementId,
      }).unwrap();
      toast.success("Response successfully updated!");
      handleCancelResponse();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't update response!");
    }
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="end"
        justifyContent="space-between"
        padding={3}
      >
        <Box display="inline-flex" alignItems="center" gap={1.5}>
          <Badge badgeContent={sortedResponses?.length} color="primary">
            <AnnouncementOutlined style={{ color: "gray" }} />
          </Badge>

          <Typography style={{ fontWeight: 500 }}>Responses</Typography>
        </Box>
        {!showResponseForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowResponseForm(true)}
          >
            Response
          </Button>
        )}
         
      </Box>

      <Divider />

      <AnnouncementResponseList
        responses={announcementDetail?.responses}
        onEditAction={handleEditResponse}
      />

      <FormDrawer
        title="Announcement Response"
        open={showResponseForm}
        onClose={handleCancelResponse}
      >
        <ResponseForm
          isBusy={addingResponse || updatingResponse}
          response={selectedResponse}
          onSubmit={(data) =>
            selectedResponse
              ? handleUpdateResponse(data)
              : handleAddResponse(data)
          }
          onCancel={handleCancelResponse}
        />
      </FormDrawer>
    </>
  );
};

export default AnnouncementResponsesTab;
